import React, { useMemo } from 'react';
import AnalysisCard from '../AnalysisCard';
import useLanguage from '@op/hooks/useLanguage';
import SvgIcon from '@home/components/SvgIcon';
import { Progress } from 'tea-component';
import { percentageFormat, reviewsFormat } from '@op/utils/value';
import { getPercentageValue, getRationPercentValue } from '@op/utils';
import { formatDateFunc } from '@op/utils/time';
import BubbleCommon, {
  keywordDrillUrlMobileFilteredReviewsRatingTips,
} from '@op/components/BubbleCommon';
import './index.scss';
import { ratingColors } from '@op/constants';

export default function MobileRatingCard(props: any) {
  const { formatMessage } = useLanguage();
  const { data, loading, error, filter, ...cardProps } = props;

  const getNumberStar = (num: number) => {
    const elements = [];
    for (let index = 0; index < num; index++) {
      elements.push(<SvgIcon key={index} type="star-action" />);
    }

    return elements;
  };
  const StarRating = ({ stats }: any) => {
    const { detail, mentions } = stats || {};
    return (
      <div className="dbo-mobile-rating-starbox">
        {[5, 4, 3, 2, 1].map((star) => (
          <div key={star} className="dbo-mobile-rating-starbox-item">
            <div className="dbo-mobile-rating-top">
              <div className="dbo-mobile-rating-top-star">
                {getNumberStar(star)}
              </div>
              <span className="dbo-mobile-rating-top-value">
                {reviewsFormat(detail?.[star])}
              </span>
            </div>
            <Progress
              key={star}
              className={`dbo-mobile-rating-progress`}
              percent={getPercentageValue(detail?.[star], mentions) * 100}
              strokeWidth={4}
              strokeColor={ratingColors[star - 1]}
            />
          </div>
        ))}
      </div>
    );
  };

  const { storeStats, score, oldScore, ratio } = useMemo(() => {
    const storeStats = data?.store_stats;
    const oldStoreStats = data?.store_stats_old;
    const score = storeStats?.score;
    const oldScore = oldStoreStats?.score;
    const ratio = getRationPercentValue(score, oldScore, 6);

    return {
      storeStats,
      score,
      oldScore,
      ratio,
    };
  }, [data]);

  return (
    <AnalysisCard
      value={score || 0}
      className="dbo-analysis-card--mobile-rating"
      title={
        <BubbleCommon
          showIcon={false}
          tipsMap={keywordDrillUrlMobileFilteredReviewsRatingTips}
        >
          {formatMessage({ id: 'Filtered Avg. Rating' })}
        </BubbleCommon>
      }
      percentValue={ratio || 0}
      footer={<StarRating stats={storeStats} />}
      loading={loading}
      // empty={false}
      bubbleProps={{
        showContent: !!score,
        oldTime: [data?.link_of_start_time, data?.link_of_end_time],
        newTime: [data?.start_time, data?.end_time],
        oldValue: oldScore,
        newValue: score,
        formateDate: formatDateFunc(filter?.date_type),
        formateValue: reviewsFormat,
      }}
      formatPercentValue={(value) => percentageFormat(value, '-', 1)}
      {...cardProps}
    />
  );
}
